import hashHexColor from '../../modules/hashHexColor'

export default (state) => (state.customer
  && state.customer.premium
  && state.customer.design
  && state.customer.design.color
  && hashHexColor(state.customer.design.color)) || null
